import { getCategories } from "../../apiCalls/urls/urlFunction";
import { UPDATE_CATEGORY_REDUCER } from "../actionTypes";

export function fetchCategories() {
    return async (dispatch) => {
        let res = await getCategories();
        if (res?.status) {
            dispatch(updateCategoryReducer(res?.data));
        } else {
            console.error(res);
        }
    };
}

export const updateCategoryReducer = (data) => {
    return {
        type: UPDATE_CATEGORY_REDUCER,
        payload: { data },
    };
};
